// extracted by mini-css-extract-plugin
export default {"linkText":"link_linkText__NS6gX","linkDecoration":"link_linkDecoration__kYBFQ","linkDisabled":"link_linkDisabled__flcIx"};